/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum GastherapyReverseOrInterruptAliases {
  CONTENT_INFORMATION_HEADER = 'content-information-header',
  DATE_FIELD = 'date-field',
  DATE_INPUT = 'date-input',
  GASTHERAPY_REVERSE_OR_INTERRUPT_LAYOUT = 'gastherapy-reverse-or-interrupt-layout',
  INTERRUPT_REASON_AUTOCOMPLETE = 'interrupt-reason-autocomplete',
  INTERRUPT_REASON_FETCH = 'interrupt-reason-fetch',
  INTERRUPT_REASON_FIELD = 'interrupt-reason-field',
  INTERRUPT_REASON_MAPPER = 'interrupt-reason-mapper',
  INTERRUPT_REASON_TEXT = 'interrupt-reason-text',
  MAIN_CONTENT_PANEL = 'main-content-panel',
  NOTES_FIELD = 'notes-field',
  NOTES_TEXT_AREA = 'notes-text-area',
  REVERSE_OR_INTERRUPT_FORM = 'reverse-or-interrupt-form',
  REVERSE_REASON_AUTOCOMPLETE = 'reverse-reason-autocomplete',
  REVERSE_REASON_FETCH = 'reverse-reason-fetch',
  REVERSE_REASON_FIELD = 'reverse-reason-field',
  REVERSE_REASON_MAPPER = 'reverse-reason-mapper',
  REVERSE_REASON_TEXT = 'reverse-reason-text',
  TEXT_GASTHERAPY_DATE = 'text-gastherapy-date',
  TEXT_GASTHERAPY_INFORMATION = 'text-gastherapy-information',
  TEXT_GASTHERAPY_TITLE = 'text-gastherapy-title',
}
export { GastherapyReverseOrInterruptAliases };
